import PageStrings from "../../viewModels/pageStrings/pageStrings";


const pageStrings =  new PageStrings();

interface IValidation
{
    label:string
    validation:string
}

// List of password requirements
export const passwordRequirements:IValidation[] = [
    {
    label: pageStrings.changePassword.text_passwordRequirements_minimumCharacters,
    validation: '.{12,}',
    },
    {
    label: pageStrings.changePassword.text_passwordRequirements_upperCase,
    validation: '[A-Z]',
    },
    {
    label: pageStrings.changePassword.text_passwordRequirements_lowerCase,
    validation: '[a-z]',
    },
    {
    label: pageStrings.changePassword.text_passwordRequirements_number,
    validation: '[0-9]',
    },
    {
    label: pageStrings.changePassword.text_passwordRequirements_specialCharacters,
    validation: '[!@#$%^&*]',
    },
];
